var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 12.5V18.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 15.625H19.1875",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 15.6237H4.60677C4.05424 15.6237 3.52433 15.4042 3.13363 15.0135C2.74293 14.6228 2.52344 14.0929 2.52344 13.5404V4.16536C2.52344 3.61283 2.74293 3.08293 3.13363 2.69223C3.52433 2.30152 4.05424 2.08203 4.60677 2.08203H13.9818C14.5343 2.08203 15.0642 2.30152 15.4549 2.69223C15.8456 3.08293 16.0651 3.61283 16.0651 4.16536V5.20703",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 15.6237H4.60677C4.05424 15.6237 3.52433 15.4042 3.13363 15.0135C2.74293 14.6228 2.52344 14.0929 2.52344 13.5404V4.16536C2.52344 3.61283 2.74293 3.08293 3.13363 2.69223C3.52433 2.30152 4.05424 2.08203 4.60677 2.08203H13.9818C14.5343 2.08203 15.0642 2.30152 15.4549 2.69223C15.8456 3.08293 16.0651 3.61283 16.0651 4.16536V5.20703",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2318 8.33203H10.8568C9.70618 8.33203 8.77344 9.26477 8.77344 10.4154V19.7904C8.77344 20.941 9.70618 21.8737 10.8568 21.8737H20.2318C21.3824 21.8737 22.3151 20.941 22.3151 19.7904V10.4154C22.3151 9.26477 21.3824 8.33203 20.2318 8.33203Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.e28cfeb4612d1b213d8fb9cf1ffd9d5c.svg";
export { ForwardRef as ReactComponent };